import { useQuery } from '@tanstack/react-query'
import { useAppContext } from '../redux/slices/appContext'
import { wealthboxGetUnlinkedTags } from '../service'
import { QUERY_KEYS } from './queryKeys'

export const useWealthboxUnlinkedTags = (options = {}) => {
  const { userId } = useAppContext()
  const { mapper = null } = options
  return useQuery({
    queryKey: [QUERY_KEYS.wealthboxUnlinkedTags, userId],
    queryFn: async () => {
      const { data } = await wealthboxGetUnlinkedTags()
      return data
    },
    select: mapper
  })
}
